<template>
    <div class="el-table-container">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)">
            <el-form-item prop="basicDataId" label="元数据模板：">
                <el-select v-model="searchForm.basicDataId" placeholder="请选择" clearable filterable>
                    <el-option
                            :key="item.id"
                            :label="item.basicDataName"
                            :value="item.id" v-for="item in basicDataIdListOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="metadataFonctionsModelId" label="功能模板：">
                <el-select v-model="searchForm.metadataFonctionsModelId" placeholder="请选择" clearable filterable>
                    <el-option
                            :key="item.id"
                            :label="item.modelName"
                            :value="item.id"
                            v-for="item in metadataFonctionsOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="keyword" label="关键字查询：">
                <el-input v-model.trim="searchForm.keyword" maxlength="50" placeholder="请输入关键字" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('configuration:mainMessageList:add')" type="primary" size="small" icon="el-icon-plus" @click="addEdit(null, 'add')">新增</el-button>
                <el-button v-if="hasPermission('configuration:mainMessageList:del')" type="danger" size="small" icon="el-icon-delete" @click="del()">批量删除</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border ref="multipleTable" row-key='id' @selection-change="selectionChangeHandle" @sort-change="sortChange">
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tableName" label="功能名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="metadataBasicDataNames" label="元数据模版" show-overflow-tooltip></el-table-column>
            <el-table-column prop="metadataFonctionsModelName" label="功能模板" show-overflow-tooltip></el-table-column>
            <el-table-column prop="defautNombre" label="默认行数" sortable show-overflow-tooltip></el-table-column>
            <el-table-column prop="tableDescription" label="功能描述" show-overflow-tooltip></el-table-column>
            <el-table-column prop="disabled" label="启用状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.disabled" active-value="0" inactive-value="1" @change="enabledChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('configuration:mainMessageList:view')" type="text" size="small"
                               @click="addEdit(scope.row, 'view')">详情
                    </el-button>
                    <el-button v-if="hasPermission('configuration:mainMessageList:edit')" type="text" size="small"
                               @click="addEdit(scope.row, 'edit')">修改
                    </el-button>
                    <el-button v-if="hasPermission('configuration:mainMessageList:copy')" type="text" size="small"
                               @click="copy(scope.row)">复制
                    </el-button>
                    <el-button v-if="hasPermission('configuration:mainMessageList:del')" type="text" size="small"
                               @click="del(scope.row.id)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="提示" width="50%" :close-on-click-modal="false" :visible.sync="visible" v-if="visible">
            <el-form size="small" :model="copyData" ref="copyData" label-width="100px">
                <el-form-item class="w100i" label="功能名称：" prop="tableName"
                              :rules="[{ required: true, whitespace: true, message: '请输入功能名称', trigger: 'blur' }]">
                    <el-input v-model.trim="copyData.tableName" placeholder="请输入功能名称（限10字）" maxlength="10" @input="tableNameIpt"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="text_center">
                <el-button size="small" @click="visible = false">取消</el-button>
                <el-button size="small" type="primary" @click="saveCopyData()" v-noMoreClick>保存</el-button>
            </div>
        </el-dialog>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <MainMessageForm ref="mainMessageForm" @refreshDataList="refreshList"></MainMessageForm>
    </div>
</template>

<script>
    import MainMessageForm from './mainMessageForm'
    export default {
        components: {MainMessageForm},
        data() {
            return {
                searchForm: {
                    keyword: '',
                    basicDataId: '',
                    metadataFonctionsModelId: '',
                    current: 1,
                    size: 20,
                    sortConfigs: []
                },
                basicDataIdListOpt: [],
                metadataFonctionsOpt: [],
                dataList: [],
                total: 0,
                dataListSelections: [],
                loading: false,
                visible: false,
                copyData: {},
            }
        },
        mounted() {
            this.getFunctionTemplate()
            this.getMetadataTemplate()
            this.refreshList()
        },
        methods: {
            refreshList(type) {
                if(type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                this.$axios(this.api.metadata.metadatatableconfigList, this.searchForm, 'post').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                    } else {
                        this.$message.error('查询失败');
                    }
                    this.loading = false
                })
            },
            // 获取功能模板
            getFunctionTemplate() {
                this.$axios(this.api.metadata.metadatafonctionsmodelSelectAll).then(data => {
                    if (data.status) {
                        this.metadataFonctionsOpt = data.data
                    }
                })
            },
            // 查询元数据模板
            getMetadataTemplate() {
                this.$axios(this.api.metadata.selectMetadataBasicDataCleanList, [], 'post').then(data => {
                    if (data.status) {
                        this.basicDataIdListOpt = data.data
                    }
                })
            },
            // 新增编辑
            addEdit(row, method) {
                this.$refs.mainMessageForm.init(row, method)
            },
            // 启用 0启用 1禁用
            enabledChange(row) {
                this.loading = true
                this.$axios(this.api.metadata.metadatatableconfigUpdateById, {id: row.id, disabled: row.disabled}, 'put').then(data => {
                    if (data.status) {
                        this.$message.success(data.msg)
                    } else {
                        this.$message.error(data.msg)
                    }
                    this.refreshList()
                    this.loading = false
                })
            },
            // 复制
            copy(item) {
                this.copyData = JSON.parse(JSON.stringify(item))
                this.copyArchivesData(0)
            },
            // 检验模板名称是否重复  checkType 1手动输入，0默认赋值；type 1保存
            checkTableName(checkType, type) {
                this.$axios(this.api.metadata.selectMetadataTableConfigByTableName, {
                    tableName: this.copyData.tableName,
                }, 'get').then(res => {
                    if (res.data) {
                        if(type) {
                            this.copyArchivesData(checkType)
                        }
                    } else {
                        if(!this.visible) {
                            this.visible = true
                        }
                        this.$nextTick(() => {
                            this.$message.error(res.msg)
                        })
                    }
                })
            },
            // 保存模板名称
            saveCopyData() {
                this.$refs['copyData'].validate((valid) => {
                    if (valid) {
                        this.checkTableName(1, 1)
                    }
                })
            },
            // 边输入边校验
            tableNameIpt() {
                this.checkTableName(1)
            },
            // 复制模板名称
            copyArchivesData(checkType) {
                this.$axios(this.api.metadata.copyMetadataTableConfig, {
                    metadataTableConfigId: this.copyData.id,
                    tableName: checkType ? this.copyData.tableName : '',
                }, 'get').then(res => {
                    if (res.status) {
                        this.$message.success('复制成功')
                        this.visible = false
                        this.refreshList()
                    } else {
                        if(!this.visible) {
                            this.visible = true
                        }
                        this.$nextTick(() => {
                            this.$message.error(res.msg)
                        })
                    }
                })
            },
            // 删除
            del(id) {
                let ids = [id];
                if (!id && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                if (!id) {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.metadata.metadatatableconfigDeleteBatchIds, ids, 'post').then(data => {
                        if (data.status) {
                            this.$message.success('删除成功')
                            this.$refs.multipleTable.clearSelection()
                            this.refreshList()
                        } else {
                            this.$message.error('删除失败')
                        }
                    })
                })
            },
            // 列表排序
            sortChange(column) {
                this.searchForm.sortConfigs = [
                    {
                        fieldName: column.prop,
                        sortOrder: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''),
                    }
                ]
                this.refreshList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            reset() {
                this.$refs.multipleTable.clearSelection()
                this.$refs.searchForm.resetFields();
                this.refreshList(1)
            }
        }
    }
</script>

<style scoped>

</style>
